import React from "react";
import { Helmet } from "react-helmet";
import HeaderEuropea from "components/Header/HeaderEuropea";

const PAGES_HIDE_HEADER: string[] = [
  "/pay-done",
  "/pay-failed",
  "/my-bookings",
];

const SiteHeader = () => {
  return (
    <>
      <Helmet>
        <title>Europea || Booking website</title>
      </Helmet>

      {!PAGES_HIDE_HEADER.includes(window.location.pathname) && (
        <HeaderEuropea />
      )}
    </>
  );
};

export default SiteHeader;
